<template>
  <div v-if="isShow()" id="activate-link">
    <div class="card-body">
      <div class="divide-y">
        <div class="row">
          <span class="col">
            <input v-model="fields.link" type="text" class="form-control" placeholder="Основная ссылка" @change="changeLink" :class="{'is-invalid': v$.link.$invalid && v$.link.$dirty}">
            <div class="mt-1">
              <ActionLink :payload="{
                action_link: fields.action_link,
                type_id: fields.type_id,
              }" @onChange="changeActionLink"/>
            </div>
            <div class="invalid-feedback" v-for="error of v$.link.$silentErrors" :key="error.$uid">
              {{ error.$message }}
            </div>
          </span>
          <span class="col-auto info">
            <FindShop
              :payload="{
                link: fields.link,
              }"
              @onFind="onFindShop"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import FindShop from "./components/find_shop/Index"
import ActionLink from "./components/action_link/Index"
import {url} from "@/plugins/vuelidator"
import {useVuelidate} from "@vuelidate/core"
import Helper from "@/services/Helper";

export default defineComponent({
  name: "ActivateLink",
  components: {
    FindShop,
    ActionLink,
  },
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
    validations: {},
  },
  setup(props, {emit}) {
    let show = ref(false)

    let $externalResults = reactive({})

    const fields = reactive({
      link: "",
      action_link: false,
    })

    const rules = {
      link: {
        url,
      },
    }

    const v$ = useVuelidate(rules, fields, {$externalResults})

    function validate(fn) {
      v$.value.$clearExternalResults()
      return v$.value.$validate().then((resp) => {
        if (resp === true) {
          fn()
        }
      })
    }

    watch(() => props.validations, (val) => {
      validate(() => {
        if (val?.button !== undefined) {
          $externalResults.scheduled_removed = val["button"][0]
        }
      })
    })

    watch(() => props.payload, (val) => {
      if (Helper.isObject(val)) {
        updateFields(val)
      }
    }, {
      immediate: true,
    })

    onMounted(async () => {
      markUnshow()
      markShow()
    })

    function updateFields(query) {
      fields.link = query.link
      fields.action_link = query.action_link
      fields.type_id = query.type_id
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function changeLink() {
      validate(() => {
        pushEvent(fields.link, fields.action_link)
      })
    }

    function changeActionLink(val) {
      fields.action_link = val?.action_link ?? false
      pushEvent(fields.link, fields.action_link)
    }

    function pushEvent(link, actionLink) {
      emit("onChange", {
        link: link,
        action_link: actionLink,
      })
    }

    function onFindShop(val) {
      let shopId = val?.shop_id ?? null
      let findManyShop = val?.find_many_shop ?? false

      emit("onFindShop", {
        shop_id: shopId,
        find_many_shop: findManyShop,
      })
    }

    return {
      isShow,
      fields,
      changeLink,
      changeActionLink,
      onFindShop,
      v$,
    }
  }
})
</script>
